import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PageTracker from '../../components/PageTracker/PageTracker';
import ScrollToTop from './ScrollToTop';
import Simple from '../Auth/Simple';
import PortalRoot from '../Portal/PortalRoot';
import OneTimeLink from '../OneTimeLink/OneTimeLink';
import { useLogout } from '../../utils/useLogout';
import { useSimpleQueryStringHelper } from '../../utils/useSimpleQueryStringHelper';

interface AppRouterProps {}

const AppRouter: React.FC<AppRouterProps> = () => {
  (window as any).logout = useLogout();

  // to support simple document login as query parameter Ex: /portal?simple=11111&...
  const { hasSimpleDocument, redirectPath } = useSimpleQueryStringHelper();
  if (hasSimpleDocument) return <Redirect to={redirectPath} />;

  return (
    <>
      <ScrollToTop />
      <Route path="/" component={PageTracker} />
      <Switch>
        <Route path="/simple/:document" component={Simple} />
        <Route path="/link/:id" component={OneTimeLink} />

        <Route path="/portal" component={PortalRoot} />
        <Redirect to="/portal" />
      </Switch>
    </>
  );
};

export default AppRouter;
